// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3hzhH","content":"style_content__3Noiu","title":"style_title__3470z","subtitle":"style_subtitle__2EIfl","wrapper":"style_wrapper__38KFI"};